import { SetStateAction, useState } from "react";
import List from "@mui/material/List";
import { Link } from "react-router-dom";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import SpaceDashboardIcon from "@mui/icons-material/SpaceDashboard";
import { ListItem } from "@mui/material";
import CardUserMinimal from "../../dashboard/card_user_minimal/CardUserMinimal";

const DrawerNav = () => {
  const [selectedIndex, setSelectedIndex] = useState(1);
  const handleListItemClick = (event: any, index: SetStateAction<number>) => {
    setSelectedIndex(index);
  };
  return (
    <div className="component-drawer-nav">
      <img src="/assets/logo/logo-2.png" style={{ width: 100, height: 50, borderRadius: 10, marginBottom: 20 }} alt="" />
      <CardUserMinimal />
      <div className="title-nav">GENERAL</div>
      <List>
      <ListItem key={"Reservation"} disablePadding>
          <Link to={"/reservation-admin"} style={{ textDecoration: "none", width: "100%", color: "#000000" }}>
            <ListItemButton
              selected={selectedIndex === 1}
              onClick={(event) => handleListItemClick(event, 1)}
              sx={{
                "&$selected": {
                  backgroundColor: "rgba(145, 158, 171, 0.12)",
                  color: "rgba(34, 10, 110,0.12)",
                  borderRadius: 3,
                  "& .MuiListItemIcon-root": {
                    color: "rgb(34, 10, 110)",
                  },
                },
                "&:hover": {
                  backgroundColor: "rgba(145, 158, 171, 0.12)",
                  color: "rgb(34, 10, 110)",
                  borderRadius: 3,
                  "& .MuiListItemIcon-root": {
                    color: "rgb(34, 10, 110)",
                  },
                },
              }}
            >
              <ListItemIcon>
                <img src="/assets/icons/navbar/ic_table.svg" />
              </ListItemIcon>
              <ListItemText primary={"Reservation"} />
            </ListItemButton>
          </Link>
        </ListItem>
        <ListItem key={"Menu"} disablePadding>
          <Link to={"/menu-admin"} style={{ textDecoration: "none", width: "100%", color: "#000000" }}>
            <ListItemButton
              selected={selectedIndex === 2}
              onClick={(event) => handleListItemClick(event, 2)}
              sx={{
                "&$selected": {
                  backgroundColor: "rgba(145, 158, 171, 0.12)",
                  color: "rgba(34, 10, 110,0.12)",
                  borderRadius: 3,
                  "& .MuiListItemIcon-root": {
                    color: "rgb(34, 10, 110)",
                  },
                },
                "&:hover": {
                  backgroundColor: "rgba(145, 158, 171, 0.12)",
                  color: "rgb(34, 10, 110)",
                  borderRadius: 3,
                  "& .MuiListItemIcon-root": {
                    color: "rgb(34, 10, 110)",
                  },
                },
              }}
            >
              <ListItemIcon>
                <img src="/assets/icons/navbar/ic_menu.svg" />
              </ListItemIcon>
              <ListItemText primary={"Menu"} />
            </ListItemButton>
          </Link>
        </ListItem>
        <ListItem key={"Evenements & Galerie"} disablePadding>
          <Link to={"/event-admin"} style={{ textDecoration: "none", width: "100%", color: "#000000" }}>
            <ListItemButton
              selected={selectedIndex === 3}
              onClick={(event) => handleListItemClick(event, 3)}
              sx={{
                "&$selected": {
                  backgroundColor: "rgba(145, 158, 171, 0.12)",
                  color: "rgba(34, 10, 110,0.12)",
                  borderRadius: 3,
                  "& .MuiListItemIcon-root": {
                    color: "rgb(34, 10, 110)",
                  },
                },
                "&:hover": {
                  backgroundColor: "rgba(145, 158, 171, 0.12)",
                  color: "rgb(34, 10, 110)",
                  borderRadius: 3,
                  "& .MuiListItemIcon-root": {
                    color: "rgb(34, 10, 110)",
                  },
                },
              }}
            >
              <ListItemIcon>
                <SpaceDashboardIcon />
              </ListItemIcon>
              <ListItemText primary={"Evenements"} />
            </ListItemButton>
          </Link>
        </ListItem>
      </List>
    </div>
  );
};

export default DrawerNav;
